import React from 'react'
import { colors } from '../../__styling/settings/colors'

export interface TheWestMarkProps {
    className?: string
    fill?: string
    width?: number
    height?: number
}

export const TheWestMark: React.FC<TheWestMarkProps> = (props) => (
    <svg
        width={props.width ?? 74}
        height={props.height ?? 65}
        viewBox="0 0 139 88"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        className={props.className}
    >
        <title>The West Australian</title>
        <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M123.176 13.2507L128.378 8.12637L129.648 9.23344L123.235 15.6397L123.033 65.0617L131.728 73.7984L136.813 68.7021L138.086 69.8083L120.258 87.7216L106.129 73.4513C94.6008 91.6226 67.8174 90.4585 55.6836 75.9251C43.3457 91.3913 18.6428 89.6148 7.0851 75.8386L5.00481 73.1583C-6.57997 57.6075 1.99903 39.3472 30.2 16.3673C20.5207 16.3673 16.3601 13.367 10.2921 13.367C6.44957 13.3671 3.53295 14.5609 3.53287 17.3869C3.53287 20.4441 5.09096 21.1441 10.7824 23.154C3.41699 23.1243 0.0640105 20.0944 0.093389 13.5437C0.093389 6.32043 6.33409 1.45686 15.1764 1.48658C22.7733 1.48662 28.6102 4.68962 35.5152 5.35958C40.1382 5.79617 44.6158 2.44651 46.7549 0.290321L46.6684 59.2081L30.1702 74.0048L30.2568 18.2037C11.3043 34.9207 10.2631 53.4142 19.3073 65.6747C27.224 76.3915 41.8709 78.6624 53.5736 73.335C41.9865 57.7521 50.5114 39.4338 78.7102 16.4539C69.0308 16.4539 64.8703 13.4545 58.8023 13.4545C54.9325 13.4271 52.043 14.6505 52.043 17.4744C52.0432 20.5311 53.6035 21.2309 59.2944 23.2406C51.9268 23.2107 48.6036 20.1834 48.6036 13.6302C48.6036 6.407 54.8171 1.54343 63.6866 1.57316C71.2561 1.57319 77.1493 4.77699 84.0542 5.44702C88.6773 5.88375 93.158 2.53345 95.2948 0.379516V15.0871L110.06 0L123.176 13.2507ZM93.5685 17.707L93.5117 59.2955L76.9839 74.0914L77.0704 18.2902C58.1178 35.0072 57.0768 53.471 66.1209 65.7613C74.9337 77.672 92.1536 79.2449 104.26 71.4112L104.23 20.9976L97.2956 14.0071L93.5685 17.707Z"
            fill={props.fill ? props.fill : colors.black}
        />
    </svg>
)
TheWestMark.displayName = 'TheWestMark'
